import { ConfigContext, useUserExperienceConfig } from '@/components';
import { useContext, useEffect, useState } from 'react';
import { DEFAULT_APP_TITLE } from '@/constants';
const UX_APP_TITLE_KEY = 'RBAC_UI_APP_TITLE';
const useDocumentTitle = () => {
    const { configState } = useContext(ConfigContext);
    const getUserExperienceConfiguration = useUserExperienceConfig();
    const [appTitle, setAppTitle] = useState(null);
    useEffect(() => {
        const fetchTitle = async () => {
            try {
                const uxConfiguration = await getUserExperienceConfiguration();
                const titleValue = uxConfiguration[UX_APP_TITLE_KEY];
                setAppTitle(typeof titleValue === 'string' ? titleValue : null);
            }
            catch (error) {
                console.error('Failed to load app title from UX config:', error);
            }
        };
        fetchTitle();
    }, [getUserExperienceConfiguration]);
    useEffect(() => {
        document.title =
            appTitle ??
                configState?.settings?.workspace_name ??
                process.env.REACT_APP_TITLE ??
                DEFAULT_APP_TITLE;
    }, [appTitle, configState?.settings?.workspace_name]);
};
export default useDocumentTitle;
